module.exports = __webpack_public_path__ + "img/class_喜好学习方式.40b5476f.png";